/* eslint-disable @typescript-eslint/camelcase */
import { push } from 'react-router-redux';
import { all, put, takeLatest } from 'redux-saga/effects';
import { messagesRequest } from 'modules/messages/actions';
import i18n from 'i18n';
import {
  editCompanyNamesFulfilled,
  editCompanyNamesRejected,
  editCompanyNamesRequest,
  getAllCompaniesFulfilled,
  getAllCompaniesOperatorFulfilled,
  getAllCompaniesOperatorRejected,
  getAllCompaniesOperatorRequest,
  getAllCompaniesRejected,
  getAllCompaniesRequest,
  getAllUserCompanyFulfilled,
  getAllUserCompanyRejected,
  getAllUserCompanyRequest,
  getCompanyFulfilled,
  getCompanyRejected,
  getCompanyRequest,
} from './actions';
import endpoints, { api } from './endpoints';

function* getCompanyRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getCompany(payload),
    });

    return yield put(getCompanyFulfilled(data));
  } catch (error) {
    return yield all([put(getCompanyRejected()), put(push('/all-companies'))]);
  }
}

function* getAllCompaniesRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getAllCompanies(payload),
    });

    return yield put(getAllCompaniesFulfilled(data));
  } catch (error) {
    return yield put(getAllCompaniesRejected());
  }
}

function* getAllCompaniesOperatorRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getAllCompaniesOperator(payload),
    });

    return yield put(getAllCompaniesOperatorFulfilled(data));
  } catch (error) {
    return yield put(getAllCompaniesOperatorRejected());
  }
}

function* getAllUserCompanyRequestSaga({ payload }) {
  const { query, company_uuid } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getAllUserCompany(company_uuid, query),
    });
    return yield put(getAllUserCompanyFulfilled(data));
  } catch (error) {
    return yield put(getAllUserCompanyRejected());
  }
}

function* editCompanyNamesRequestSaga({ payload }) {
  const { id, values } = payload;
  try {
    yield api.patch({
      url: endpoints.editCompanyNames(id),
      data: { alias: values.alias },
    });

    return yield all([
      put(editCompanyNamesFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('ALIAS_CREATED_SUCCESSFULLY_KEY'),
        })
      ),
      put(getCompanyRequest(id)),
    ]);
  } catch (error) {
    return yield put(editCompanyNamesRejected());
  }
}

export default all([
  takeLatest(getCompanyRequest, getCompanyRequestSaga),
  takeLatest(getAllCompaniesRequest, getAllCompaniesRequestSaga),
  takeLatest(getAllUserCompanyRequest, getAllUserCompanyRequestSaga),
  takeLatest(
    getAllCompaniesOperatorRequest,
    getAllCompaniesOperatorRequestSaga
  ),
  takeLatest(editCompanyNamesRequest, editCompanyNamesRequestSaga),
]);
